import { Slider } from "./components/slider";
import { SliderDots } from "./components/sliderdots";
import { Component } from "./helpers/component";
import { Lazyload } from "./helpers/lazyload";
import { Svg } from "./helpers/svg";
import { Utils } from "./helpers/utils";

Utils.credits();

Component.register('Slider', Slider);
Component.register('SliderDots', SliderDots);

document.addEventListener("DOMContentLoaded", () => {

  Svg.fixIds(document, '[class*="zaux-ico"]');

  Lazyload.init();

  Component.initAll();

});
